import { module } from "angular";
import { ConfidencePreview } from "./directives/confidence-preview.directive";
import { metricValue } from "./filters/metric-value.filter";
import { metric } from "./filters/metric.filter";
import { MetricService } from "./services/metric.service";

const mod = module("metricsCore", []);

mod.service("MetricService", MetricService);

mod.directive("confidencePreview", ConfidencePreview.factory());

mod.filter("metric", metric);
mod.filter("metricValue", metricValue);

export default mod.name;
